import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export const FileUpload = ({
  allowedExtensions,
  allowMultipleFiles,
  id,
  errors,
  name,
  onChange,
  placeholder
}) => {
  return (
    <Grid item xs={12} sx={{ height: '100%' }}>
      <label className="w-100" style={{ cursor: 'pointer',
          height: '100%',
          display: 'block' }}>
        <input
          style={{ display: 'none' }}
          id={id}
          name={name}
          type="file"
          multiple={allowMultipleFiles}
          accept={allowedExtensions}
          onChange={onChange}
        />
        
        <Box
          sx={{
            textAlign: 'center',
            padding: '20px',
            border: '2px dashed #ccc',
            borderRadius: '8px',
            backgroundColor: '#fafafa',
            transition: 'all 0.3s ease',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            '&:hover': {
              borderColor: '#7C9082',
              backgroundColor: '#f0f7f0',
            }
          }}
        >
          <CloudUploadIcon 
            sx={{ 
              fontSize: '48px', 
              color: '#7C9082',
              marginBottom: '10px'
            }} 
          />
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#666',
              marginBottom: '5px'
            }}
          >
            {placeholder || 'Click to upload image'}
          </Typography>
          
          <Typography 
            variant="caption" 
            sx={{ 
              color: '#999',
              fontSize: '12px'
            }}
          >
            {allowMultipleFiles ? 'Multiple files allowed' : 'Single file only'}
          </Typography>
        </Box>
        
        {errors && (
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'red',
              display: 'block',
              textAlign: 'center',
              marginTop: '8px'
            }}
          >
            {errors}
          </Typography>
        )}
      </label>
    </Grid>
  );
};
